document.addEventListener('DOMContentLoaded', function() {
    const sectionWrapper = document.querySelector('.fb-section-reviews');
    if (!sectionWrapper) return;

    const carouselContainer = sectionWrapper.querySelector('.js-carousel-container');
    const track = sectionWrapper.querySelector('.js-carousel-track');
    const nextButton = sectionWrapper.querySelector('.js-next-button');
    const prevButton = sectionWrapper.querySelector('.js-prev-button');
    const thumbnailsContainer = sectionWrapper.querySelector('.js-thumbnails-container');
    const reviewLink = sectionWrapper.querySelector('#fb-review-link');

    if (!carouselContainer || !track || !nextButton || !prevButton) return;

    const slides = Array.from(track.children);
    if (slides.length === 0) return;

    if (reviewLink) {
        const mobileUrl = 'fb://page/108486001968875/reviews';
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
            reviewLink.href = mobileUrl;
        }
    }

    let currentIndex = 0;

    const getSlidesToShow = () => {
        if (window.innerWidth >= 990) return 3;
        if (window.innerWidth >= 750) return 2;
        return 1;
    };

    const updateCarousel = () => {
        if (window.innerWidth < 750) return;
        const slidesToShow = getSlidesToShow();
        const slideWidth = slides[0].getBoundingClientRect().width;
        const spaceBetween = parseInt(getComputedStyle(track).gap) || 0;
        const totalMove = (slideWidth + spaceBetween) * currentIndex;
        track.style.transform = `translateX(-${totalMove}px)`;
        prevButton.style.opacity = currentIndex === 0 ? '0' : '1';
        prevButton.disabled = currentIndex === 0;
        const isAtEnd = currentIndex >= slides.length - slidesToShow;
        nextButton.style.opacity = isAtEnd ? '0' : '1';
        nextButton.disabled = isAtEnd;
    };

    const navigate = (direction) => {
        const slidesToShow = getSlidesToShow();
        currentIndex += direction;
        if (currentIndex < 0) currentIndex = 0;
        if (currentIndex > slides.length - slidesToShow) currentIndex = slides.length - slidesToShow;
        updateCarousel();
    };

    nextButton.addEventListener('click', () => navigate(1));
    prevButton.addEventListener('click', () => navigate(-1));

    if (thumbnailsContainer) {
        const thumbnails = [];
        slides.forEach((_, index) => {
            const thumb = document.createElement('button');
            thumb.classList.add('fb-thumbnail-item');
            if (index === 0) {
                thumb.classList.add('is-active');
            }
            thumb.setAttribute('aria-label', `Eiti į atsiliepimą ${index + 1}`);
            thumbnailsContainer.appendChild(thumb);
            thumbnails.push(thumb);
        });

        const getScrollAmount = () => {
            if (slides.length === 0) return 0;
            const slideWidth = slides[0].offsetWidth;
            const gap = parseInt(getComputedStyle(track).gap) || 20;
            return slideWidth + gap;
        };

        const updateActiveThumbnail = () => {
            if (window.innerWidth >= 750) {
                thumbnails.forEach(t => t.classList.remove('is-active'));
                return;
            };
            const scrollAmount = getScrollAmount();
            if (scrollAmount === 0) return;
            const currentThumbIndex = Math.round(carouselContainer.scrollLeft / scrollAmount);
            thumbnails.forEach((thumb, index) => {
                thumb.classList.toggle('is-active', index === currentThumbIndex);
            });
        };

        thumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                const scrollAmount = getScrollAmount();
                carouselContainer.scrollTo({
                    left: index * scrollAmount,
                    behavior: 'smooth'
                });
            });
        });

        carouselContainer.addEventListener('scroll', updateActiveThumbnail);

        let isDragging = false,
            isScrolling = false,
            startX, startY,
            startScrollLeft,
            draggedDistance = 0,
            initialIndex = 0;

        const handleDragStart = (e) => {
            if (window.innerWidth >= 750) return;
            isDragging = true;
            isScrolling = false;
            startX = e.touches ? e.touches[0].pageX : e.pageX;
            startY = e.touches ? e.touches[0].pageY : e.pageY;
            startScrollLeft = carouselContainer.scrollLeft;
            carouselContainer.style.scrollBehavior = 'auto';
            draggedDistance = 0;

            const scrollAmount = getScrollAmount();
            if (scrollAmount > 0) {
                initialIndex = Math.round(startScrollLeft / scrollAmount);
            }
        };

        const handleDragMove = (e) => {
            if (!isDragging || window.innerWidth >= 750) return;
            const x = e.touches ? e.touches[0].pageX : e.pageX;
            const y = e.touches ? e.touches[0].pageY : e.pageY;
            if (isScrolling === false) {
                if (Math.abs(x - startX) > Math.abs(y - startY)) {
                    isScrolling = 'horizontal';
                } else {
                    isScrolling = 'vertical';
                }
            }
            if (isScrolling === 'horizontal') {
                e.preventDefault();
                draggedDistance = x - startX;
                carouselContainer.scrollLeft = startScrollLeft - draggedDistance;
            }
        };

        const handleDragEnd = () => {
            if (!isDragging || window.innerWidth >= 750) return;
            isDragging = false;

            if (isScrolling === 'horizontal') {
                const scrollAmount = getScrollAmount();
                if (scrollAmount === 0) return;
                const swipeThreshold = 50;
                let finalIndex = initialIndex;
                if (draggedDistance < -swipeThreshold) {
                    finalIndex = initialIndex + 1;
                } else if (draggedDistance > swipeThreshold) {
                    finalIndex = initialIndex - 1;
                }
                finalIndex = Math.max(0, Math.min(finalIndex, slides.length - 1));
                carouselContainer.scrollTo({
                    left: finalIndex * scrollAmount,
                    behavior: 'smooth'
                });
            }
        };

        carouselContainer.addEventListener('mousedown', handleDragStart);
        carouselContainer.addEventListener('touchstart', handleDragStart, {
            passive: true
        });
        carouselContainer.addEventListener('mousemove', handleDragMove);
        carouselContainer.addEventListener('touchmove', handleDragMove, {
            passive: false
        });
        document.addEventListener('mouseup', handleDragEnd);
        document.addEventListener('touchend', handleDragEnd);
        carouselContainer.addEventListener('mouseleave', () => {
            if (isDragging) handleDragEnd();
        });
    }

    const initialize = () => {
        if (window.innerWidth < 750) {
            track.style.transform = 'none';
            carouselContainer.scrollLeft = 0;
        } else {
            carouselContainer.scrollLeft = 0;
            currentIndex = 0;
            updateCarousel();
        }
        if (thumbnailsContainer) {
            updateActiveThumbnail();
        }
    };

    window.addEventListener('resize', initialize);

    const mainSection = carouselContainer.closest('.fb-section');
    if (mainSection && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, observerInstance) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                initialize();
                observerInstance.unobserve(mainSection);
            }
        }, {
            root: null,
            threshold: 0.1
        });
        observer.observe(mainSection);
    } else {
        setTimeout(initialize, 150);
    }
});